import React from 'react';
import { SortByFilter } from '@periscopes/general/filters';
export const SortedBySelect = ({ defaultValue, onChange, queryParams, sortOptions }) => {
    if (!sortOptions.length) {
        return null;
    }
    const defaultOption = defaultValue !== null && defaultValue !== void 0 ? defaultValue : sortOptions[0];
    return (React.createElement(SortByFilter, { defaultSortOption: defaultOption, onChange: onChange, options: sortOptions, queryParams: queryParams, sortIcon: true }));
};
